module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Medium Italic.20e4f889.woff";